
const matcher = /(https?:\/\/)?(www\.)?([^\/]+)/;

export function extractHostName(url: string) {
    const results = matcher.exec(url);
    if (results === null || results.length < 4) {
        return "";
    }
    return results[3];
}
